
import Vue from 'vue'
import { Plugins } from '@capacitor/core'
const { Storage,Motion,Network ,App,BackgroundTask} = Plugins
import helpers from './helpers'

const dorient = {
    portrait: 'Portrait',
    portraitUpsideDown: 'PortraitUpsideDown',
    landscapeLeft: 'LandscapeLeft',
    landscapeRight: 'LandscapeRight',
    unknown:'Unknown'
}
export const DeviceEventBus = new Vue({
 
    data(){
        return {
            orientation:dorient.unknown,
            lastOrientation:dorient.unknown,
        }
    },
    methods:{
        init(){
        //    console.log('DeviceEventBus:Init')
           Motion.addListener('orientation',this.OrientationHandler2)  
            // screen.orientation.onchange = function (){
            //     // logs 'portrait' or 'landscape'
            //     console.log(screen.orientation.type.match(/\w+/)[0]);
            // };
        
            window.addEventListener("orientationchange",this.windowOrientationHandler , false);
        
            
            Network.addListener('networkStatusChange', this.NetworkHandler )
            App.addListener('appStateChange', this.statusHandler) 
        },
        windowOrientationHandler (){
            console.log( "Announce the new orientation number" )
            // alert(window.orientation);
            this.$emit('orientation',{})
        },
         OrientationHandler2(e){
            console.log("DeviceEventBus OrientationHandler2")
            console.log(e)
            let  numOrientationChanges =0
            let orientationLabel,orientationLabelWTime,curTime =  new Date()
            let orOb = {
                orientation :null,
                size:null
            }

        // console.log('Alpha ',e.alpha)
        // console.log('Beta ',e.beta)
        // console.log('Gamma ',e.gamma)
                             
        if (Math.abs(window.orientation) === 90) {
            // Landscape
            orientationLabel = "LANDSCAPE " + window.orientation;
        } else {
            // Portrait
            orientationLabel = "PORTRAIT " + window.orientation;
        }
        
        if (this.lastOrientation !== window.orientation) {
            
            if (numOrientationChanges === 0) {
                
                orientationLabelWTime=   orientationLabel + " (" + curTime + " ms)";
               
            } else if (numOrientationChanges === 1) {
                 
                orientationLabelWTime=  orientationLabel + " (" + curTime + " ms)";
               
            }
            orOb.orientation = orientationLabel
            orOb.size = helpers.screenSize()
            this.lastOrientation = window.orientation;
             numOrientationChanges += 1;
            // console.log(helpers.screenSize())
            
            this.$emit('orientation',orOb)
        }
           
        },
        NetworkHandler(status){
            console.log("***************************************************\n") 
            console.log("DeviceEventBus:NetworkHandler")
            console.log(JSON.stringify( status))
            console.log("***************************************************\n") 
            
            this.$emit('NetWorkStatus',status)
        },
        async getNetWorkStatus(){
            return await Network.getStatus();
        },
        statusHandler (state){
            // console.log("DeviceEventBus:statusHandler: ",state)
            this.$emit('appState',state)
        },
        OrientationHandler(e){

            try{
                if(window.orientation)
                {
                    switch (window.orientation) {  
                        case 0:  
                            // Portrait 
                            this.orientation=dorient.portrait
                            break; 
                        case 180:  
                            // Portrait (Upside-down)
                            this.orientation=dorient.portraitUpsideDown
                            break; 
                        case -90:  
                            // Landscape (Clockwise)
                            this.orientation=dorient.landscapeRight
                            break;  
                        case 90:  
                            // Landscape  (Counterclockwise)
                            this.orientation=dorient.landscapeLeft
                            break;
                    }
                    // console.log('orientation', e,this.cOr)
                    // console.log('Alpha ',e.alpha)
                    // console.log('Beta ',e.beta)
                    // console.log('Gamma ',e.gamma)
                    // console.log(this.orientation)
                    // console.log(this.orientation)
                    console.log('*************S***************')
                    console.log('WO '+window.orientation)
                    this.$emit('orientation',this.orientation)
                    // this.$emit('orientation',this.orientation)
                    console.log('O '+this.orientation)
                    console.log('*************E***************')
                
                    //  this.cOr++
                }    
        
            }catch(e){
                console.log(e)
            }
          
            
        }
    }

})